import { on, select, selectAll, addClass, removeClass, getData, setAttribute } from 'modules/dom'

const ACTIVATE_CLASS = 'is-active'
const SLIDEOUT_ACTIVE = 'slideout-activate'
const WEBINAR_LOGIN_REQUIRED_SELECTOR = '.js-webinar-login-required'
const WEBINAR_CLASS = 'modal-login--webinars'
const LOGIN_MODAL_TRIGGER_SELECTOR = '.js-login-modal-trigger'
const LINK_MODAL_LOGIN_FOOTER_SELECTOR = '.modal-login__text a'

export default function (el) {
  const closeButton = select('.js-close-modal', el)
  const openModalButton = selectAll(getData('activate-element', el))
  const inputEmailEl = select('.login-username input', el)
  const inputPasswordEl = select('.login-password input', el)
  const webinarRequiredLoginEls = selectAll(WEBINAR_LOGIN_REQUIRED_SELECTOR)
  const loginModalTriggerEls = selectAll(LOGIN_MODAL_TRIGGER_SELECTOR)
  const activateModal = () => addClass(ACTIVATE_CLASS, el)
  const deactivateModal = () => {
    removeClass(ACTIVATE_CLASS, el)
  }
  if (openModalButton) {
    on('click', function (e) {
      e.preventDefault()
      removeClass(WEBINAR_CLASS, el)
      activateModal()
    }, openModalButton)
  }
  if (closeButton) {
    on('click', deactivateModal, closeButton)
  }
  if (inputEmailEl) {
    setAttribute('placeholder', 'Email', inputEmailEl)
  }
  if (inputPasswordEl) {
    setAttribute('placeholder', 'Password', inputPasswordEl)
  }
  if (webinarRequiredLoginEls.length) {
    on('click', (e) => {
      const zoomMeetingId = e.currentTarget.getAttribute('data-zoom-meeting-id')
      e.preventDefault()
      addClass(WEBINAR_CLASS, el)
      activateModal()

      if (zoomMeetingId) {
        const urlParams = new URLSearchParams(window.location.search)
        urlParams.append('join-zoom-meeting-id', zoomMeetingId)
        const redirectEls = document.querySelectorAll('[name=redirect_to]')
        if (redirectEls.length) {
          redirectEls.forEach(redirectEl => {
            redirectEl.setAttribute('value', `${window.location.origin}${window.location.pathname}?${urlParams.toString()}`)
          })
        }
      }
    }, webinarRequiredLoginEls)
  }
  if (loginModalTriggerEls.length) {
    on('click', (e) => {
      e.preventDefault()
      activateModal()
    }, loginModalTriggerEls)
  }

  // Set current scroll position when page is reloaded
  window.addEventListener('beforeunload', () => {
    const scrollPosition = window.scrollY
    window.sessionStorage.setItem('scrollPosition', scrollPosition)
  })

  // focusout last link footer move to focus close button modal
  const footerModalLink = select(LINK_MODAL_LOGIN_FOOTER_SELECTOR, el)
  if (footerModalLink) {
    on('focusout', function (e) {
      closeButton.focus()
    }, footerModalLink)
  }
}
